import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";
import { setError, setLoaded, setLoading } from "../../LoaderSlice";

export const GetDisassembleInput = createAsyncThunk(
  'Disassemble/fetchDisassembleInput',
  async (_, { dispatch,rejectWithValue }) => {
    try {
      dispatch(setLoading({ action: 'DisassembleData'}))
      const response = await apiClient.get('Disassemble/GetDisassembleInput');
      dispatch(setLoaded({ action: 'DisassembleData'}));
      return response.data;  // Return data to be stored
    } catch (error) {
      dispatch(setError({ action: 'DisassembleData', message: error.response?.data}));
      dispatch(setLoaded({ action: 'DisassembleData'}));
      return rejectWithValue(error.response?.data || 'Error fetching data');
    }
  }
);

export const GetDisassembleRecipt = createAsyncThunk(
  'Disassemble/fetchReciptData',
  async ({ DocEntry }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `Disassemble/GetDisassembleRecipt?DocEntry=${DocEntry}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching item details');
    }
  }
);

export const GetDisassembleReciptList = createAsyncThunk(
  'Disassemble/fetchReciptDataList',
  async ({ DocEntry }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `Disassemble/GetDisassembleReciptList?DocEntry=${DocEntry}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching item details');
    }
  }
);

export const GetDisassembleBatch = createAsyncThunk(
  'Disassemble/fetchDisassembleBatch',
  async ({ItemCode}, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `Disassemble/GetDisassembleBatch?ItemCode=${ItemCode}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching item details');
    }
  }
);

export const GetDisassembleIssue = createAsyncThunk(
  'Disassemble/fetchReceiptInput',
  async ({ItemCode, DocEntry}, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `Disassemble/GetDisassembleIssue?ItemCode=${ItemCode}&DocEntry=${DocEntry}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching item details');
    }
  }
);

export const postDisassembleIT = createAsyncThunk(
  'Disassemble/DisassembleIT',  // Action name for redux
  async (tableBody, { rejectWithValue }) => {
    try {
      // Make the POST request with updatedRows as the payload
      const response = await apiClient.post('Disassemble/GetDisassembleIT', tableBody);
      return response.data;  // Return the response data to be stored in Redux
    } catch (error) {
      // Handle the error and return it with rejectWithValue for better error handling
      return rejectWithValue(error.response?.data || 'Error posting Inventory Transfer');
    }
  }
);

export const postDisassembleReceipt = createAsyncThunk(
  'Disassemble/DisassembleReceipt',  // Action name for redux
  async (dataToPost, { rejectWithValue }) => {
    try {
      // Make the POST request with updatedRows as the payload
      const response = await apiClient.post('Disassemble/PostDisassemble', dataToPost);
      return response.data;  // Return the response data to be stored in Redux
    } catch (error) {
      // Handle the error and return it with rejectWithValue for better error handling
      return rejectWithValue(error.response?.data || 'Error posting Inventory Transfer');
    }
  }
);

export const resetError = () => ({
  type: 'RESET_ERROR'
});
// export const postITR = createAsyncThunk(
//   'InventoryTransfer/postITR',  // Action name for redux
//   async (tableBody, { rejectWithValue }) => {
//     try {
//       // Make the POST request with updatedRows as the payload
//       const response = await apiClient.post('InventoryTransfer/PostItInput', tableBody);
//       return response.data;  // Return the response data to be stored in Redux
//     } catch (error) {
//       // Handle the error and return it with rejectWithValue for better error handling
//       return rejectWithValue(error.response?.data || 'Error posting Inventory Transfer');
//     }
//   }
// );

